export default __webpack_public_path__ + "static/media/generic-banner.a55e78af.png";